<template>
  <div
    class="select"
    :class="{'select--no-border': noBorder}"
  >
    <div class="select__input-content">
      <select
        class="select__input"
        :id="name"
        :name="name"
        v-model="newValue"
        :required="required"
        @input="update"
        placeholder=" "
        data-vv-as=" "
      >
        <slot></slot>
      </select>
      <label :for="name" class="select__label">{{ placeholder }}</label>
    </div>
    <span class="select__line"></span>
    <small class="select__error"></small>
  </div>
</template>

<script>
export default {
  name: 'app-select',
  data() {
    return {
      newValue: this.value
    }
  },
  props: {
    value: [String, Number],
    name: String,
    placeholder: String,
    required: Boolean,
    noBorder: Boolean
  },
  methods: {
    update() {
      this.$emit('input', this.newValue)
    }
  },
  watch: {
    value(newVal) {
      this.newValue = newVal
    },
    newValue() {
      this.update()
    }
  }
}
</script>

<style lang="scss">
.select {
  width: 100%;
  position: relative;
  margin: 10px 0 8px;

  &__input-content {
    position: relative;

    &::before {
      @include pseudo-fontawesome;
      content: '\f0dd';
      position: absolute;
      top: calc(50% - 12px);
      right: 4px;
      width: 12px;
      height: 12px;
      pointer-events: none;
    }
  }

  &__input {
    all: unset;
    box-sizing: border-box;
    border-bottom: solid 1px #ccc;
    color: #333;
    padding: 12px;
    width: 100%;
    text-align: left;
    transition: 0.3s;
    height: 44px;

    &:-moz-focusring {
      color: transparent;
      text-shadow: 0 0 0 #000;
    }

    option:not(:checked) {
      color: black;
    }
  }

  &__label {
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 1em;
    color: #ccc;
    font-family: $mainFont;
    transition: 0.3;
    transition: 0.3s;
    cursor: text;
    user-select: none;
  }

  &__line {
    content: '';
    position: absolute;
    bottom: 14px;
    height: 2px;
    background-color: $primaryColor;
    width: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: 0.3s;
    border-radius: 2px;
  }

  &--no-border & {
    &__input {
      border-bottom: 0;
    }

    &__line {
      display: none;
    }
  }

  &__error {
    display: block;
    height: 14px;
    width: 100%;
    text-align: right;
    font-size: 0.7em;
    color: $errorColor;
    visibility: visible;
    opacity: 1;
    transition: 0.3s;
    transform: translateY(0px);

    &:empty {
      height: 0;
      visibility: hidden;
      opacity: 0;
      transform: translateY(4px);
    }
  }

  &--error &__input{
    border-color: red !important;
  }

  &--error &__error {
    visibility: visible;
    opacity: 1;
  }

  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  option:not(:checked) {
    color: black;
  }

  &__input:not(:placeholder-shown) + &__label {
    color: #333;
  }

  &__input:focus + &__label {
    color: $primaryColor;
  }

  &__input:focus + &__label,
  &__input:not(:placeholder-shown) + &__label {
    top: -12px;
    left: 0;
    font-size: 12px;
  }

  &__input:focus ~ &__line{
    width: 100%;
  }

  // &__input:focus {
  //   border-color: $primaryColor;
  // }
}
</style>

